<template>
  <div class="card inset">
    <div class="compare1">
      <div data-v-17f486c6="" class="subheader" @click="showSame1 = !showSame1">
        <div>Vergelijk</div>
        <div>
          Huidige intake
          {{ $parent.userOverview.create_date.split('T')[0] }}
        </div>
        <div v-if="$parent.previousCompleted">
          Vorige intake
          {{ $parent.previousCompleted.split('T')[0] }}
        </div>
        <awesomeIcon v-if="!showSame1" icon="chevron-down"/>
        <awesomeIcon v-else icon="chevron-up"/>
      </div>
      <div v-for="(item1, index) in compare1" :key="`compare-${index}`">
        <div
          v-if="typeof item1 === 'object'"
          :class="['msg', item1._compare ? 'valid': 'invalid',
            item1._compare && !showSame1 ? 'hidden' : '']"
        >
          <div>{{item1._name}}</div>
          <div>{{item1._reverse ? item1._intake2 : item1._intake}}</div>
          <div>{{item1._reverse ? item1._intake : item1._intake2}}</div>
        </div>
        <div v-for="(item2, index2) in item1" :key="`compare-${index}-${index2}`">
          <div
            v-if="typeof item2 === 'object'"
            :class="['msg', item2._compare ? 'valid': 'invalid',
              item2._compare && !showSame1 ? 'hidden' : '']"
          >
            <div>{{item1._name}} - {{item2._name}}</div>
            <div>{{item2._reverse ? item2._intake2 : item2._intake}}<br></div>
            <div>{{item2._reverse ? item2._intake : item2._intake2}}<br></div>
          </div>
          <div v-for="(item3, index3) in item2" :key="`compare-${index}-${index2}-${index3}`">
            <div
              v-if="typeof item3 === 'object'"
              :class="['msg', item3._compare ? 'valid': 'invalid',
                item3._compare && !showSame1 ? 'hidden' : '']"
            >
              <div>{{item1._name}} - {{item2._name}} - {{item3._name}}</div>
              <div>{{item3._reverse ? item3._intake2 : item3._intake}}<br></div>
              <div>{{item3._reverse ? item3._intake : item3._intake2}}<br></div>
            </div>
          </div>
        </div>
      </div>
      <div class="msg inset" v-if="$parent.status !== 'Afgerond'">
        Door op de knop "<b>Snel accepteren (zonder/met melding)</b>" te klikken gebeurt het
        volgende als het nog niet (<awesomeIcon icon="times" style="color: red" />) is uitgevoerd:
        <br /><br />
        <awesomeIcon
          :icon="quickAcceptCheck('profiles') ? 'times' : 'check'"
          :style="{
            color: quickAcceptCheck('profiles')  ? 'red' : 'green',
          }"
        />
        - De profielen {{
          quickAcceptCheck('profiles')
            ? 'worden hersteld naar hun originele staat als in de vorige intake'
            : 'zijn'
        }}
        (maximaal <b>{{ this.$parent.previousIntakeAdmin.beleggen.maxProfile }}</b> &
        start <b>{{ this.$parent.previousIntakeAdmin.beleggen.profile }}</b>).
        <br />
        <awesomeIcon
          :icon="quickAcceptCheck('user') ? 'check' : 'times'"
          :style="{
            color: quickAcceptCheck('user')  ? 'green' : 'red',
          }"
        />
        - De originele indiener
        {{ find(this.$parent.users, { email: $parent.previousEmail }).name }}
        (<b>{{ $parent.previousEmail }}</b>)
        {{ quickAcceptCheck('user') ? 'is gekoppeld' : 'wordt teruggekoppeld' }}.
        <br />
        <awesomeIcon
          :icon="quickAcceptCheck('intake') ? 'check' : 'times'"
          :style="{
            color: quickAcceptCheck('intake')  ? 'green' : 'red',
          }"
        />
        - De intake {{ quickAcceptCheck('intake') ? 'is' : 'wordt' }} ingediend.
        <br /><br />
        <button style="float:right" @click="quickAccept(false)">
          Snel accepteren (zonder melding)
        </button>
        <button style="float:right; margin-right: 10px;" @click="quickAccept(true)">
          Snel accepteren (met melding)
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { find, cloneDeep } from 'lodash-es';

export default {
  name: 'ComparePage',
  data() {
    return {
      compare1: {},
      showSame1: false,
      diffIntake: {},
    };
  },
  mounted() {
    // forwards
    this.checkIntake(
      cloneDeep(this.$parent.intake),
      cloneDeep(this.$parent.previousIntake),
      this.diffIntake,
    );
    this.compare1 = cloneDeep(this.diffIntake);

    // remove unnecessary keys
    delete this.compare1.utm;
    delete this.compare1.step;
    delete this.compare1.totalFields;
    delete this.compare1.wrongFields;
    delete this.compare1.goalData.riskChanged;
    delete this.compare1.goalData.vtrChanged;
    delete this.compare1.rekeningData.step;
    delete this.compare1.goalData.reset;
  },
  methods: {
    find,
    /* eslint-disable */
    checkIntake(intake, intake2, diffIntake, reverse = false) {
      for (let key in intake) {
        if (intake[key] === undefined || intake[key] === null) {
          intake[key] = '';
        }
        if (intake2[key] === undefined || intake2[key] === null) {
          intake2[key] = '';
        }
        if (!diffIntake[`${key}`]) {
          if (typeof intake[key] === 'object') {
            diffIntake[`${key}`] = {
              _name: `${key}`,
              _compare: ((intake2[key] ? 'Yes' : 'No') === (intake[key] ? 'Yes' : 'No')) ? true : false,
              _intake2: intake2[key] ? 'Yes' : 'No',
              _intake: intake[key] ? 'Yes' : 'No',
              _reverse: reverse,
            };
            this.checkIntake(intake[key] || {}, intake2[key] || {}, diffIntake[key], reverse);
          } else if (intake[key] == intake2[key]) {
            diffIntake[`${key}`] =  {
              _name: `${key}`,
              _compare: true,
              _intake2: `${intake2[key]}`,
              _intake: `${intake[key]}`,
              _reverse: reverse,
            };
          } else {
            diffIntake[`${key}`] =  {
              _name: `${key}`,
              _compare: false,
              _intake2: `${intake2[key]}`,
              _intake: `${intake[key]}`,
              _reverse: reverse,
            };
          }
        }
      }
      if (!reverse) {
        this.checkIntake(intake2 || {}, intake || {}, diffIntake, true);
      }
    },
    /* eslint-enable */
    quickAcceptCheck(check) {
      switch (check) {
        case 'profiles':
          return this.$parent.previousIntakeAdmin.beleggen.maxProfile
            !== this.$parent.intakeAdmin.beleggen.maxProfile
            || this.$parent.previousIntakeAdmin.beleggen.profile
            !== this.$parent.intakeAdmin.beleggen.profile;
        case 'user':
          return this.$parent.previousEmail === this.$parent.email;
        default:
          return this.$parent.status === 'Ingeleverd';
      }
    },
    quickAccept(message = true) {
      this.sdk.quickAccept(this.$parent.getQueryVariable('intake'), (response) => {
        if (response.status === 200) {
          window.onbeforeunload = () => {};
          window.location.href = '?';
        } else if (response.status === 404) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: response.data.message,
            cb: () => {},
          });
        } else if (response.status === 403) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: 'U heeft niet de bevoegdheden om deze actie uit te voeren',
            cb: () => {},
          });
        }
      }, message);
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  cursor: pointer;
  margin: 10px 5px;
  display: inline-block;
}
.hidden {
  display: none;
}
.msg div, .subheader div {
  width: 33%;
  display: inline-block;
}
.msg div {
  &:first-child {
    font-weight: bold;
  }
}
.compare1 .msg div,
.compare2 .msg div {
  &:nth-child(3) {
    opacity: 0.5;
  }
}
.subheader {
  cursor: pointer;
  position: relative;
  .fa-icon {
    position: absolute;
    top: 12px;
    right: 10px;
  }
}
</style>
